import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { WifiOff } from "lucide-react";

export function Offline() {
  const navigate = useNavigate();
  return (
    <Layout>
      <section className="max-w-xl mx-auto px-4 py-20 text-center">
        <WifiOff className="h-12 w-12 mx-auto text-muted-foreground" />
        <h1 className="font-display text-4xl mt-4">Offline</h1>
        <p className="mt-3 text-muted-foreground">
          You appear to be offline. Already-loaded games keep working — try going home and resuming your saved game.
        </p>
        <Button className="rounded-full mt-6" onClick={() => navigate("/")}>Home</Button>
      </section>
    </Layout>
  );
}
